import { t } from "@/i18n-js/instance";
import type { AddonsDetails } from "@circle-react/types/CurrentPlan";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

type AddonItem = AddonsDetails["items"][number];

interface AddonRowProps {
  item: AddonItem;
}

export const AddonRow = ({ item }: AddonRowProps) => (
  <div className="flex items-center justify-between">
    <div className="flex items-center gap-x-2">
      <Icon
        type="circle-checked"
        size={16}
        useWithFillCurrentColor
        useWithStrokeCurrentColor
        className="text-default"
      />
      <Typography.BodySm>
        {item.value} {item.label}
      </Typography.BodySm>
      {typeof item.remaining === "number" && (
        <Typography.BodySm color="text-light">
          {t("settings.billing.add_ons.remaining_resources", {
            count: item.remaining,
          })}
        </Typography.BodySm>
      )}
    </div>
    <Typography.BodySm weight="semibold">{item.amount}</Typography.BodySm>
  </div>
);
